export default "__VITE_ASSET__DOZNmfPC__"